import { RouterProvider } from '@tanstack/react-router'

import { NotFoundPage } from '@/shared/components/common/NotFoundPage'
import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import { Loader } from '@/shared/components/ui/loader'
import { router } from '@/shared/lib/router/router'
import Sentry from '@/shared/lib/sentry'

import { QueryClientProvider } from '../providers/QueryClientProvider'
import { ThemeProvider } from '../providers/ThemeProvider'

function App() {
	return (
		<ThemeProvider>
			<QueryClientProvider>
				<ErrorBoundary>
					<RouterProvider
						defaultNotFoundComponent={() => <NotFoundPage />}
						defaultPendingComponent={() => (
							<div className='bg-soft-green flex h-dvh items-center justify-center'>
								<Loader className='size-12' />
							</div>
						)}
						router={router}
					/>
				</ErrorBoundary>
			</QueryClientProvider>
		</ThemeProvider>
	)
}

export default Sentry.withProfiler(App)
